import { useState } from 'react';

const useError = () => {
  const [error, setError] = useState();

  const handleError = (e, throwError = true) => {
    setError(e);
    if (throwError) {
      throw e;
    }
  };

  return {
    error,
    setError,
    handleError,
  };
};

export default useError;
